"use client"

import { generateResponsiveCSS } from "@/(admin)/modules/ui-builder/config/lib/helper"
import { ServiceSidebarProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ServiceSidebarContent } from "./components/ServiceSidebarContent"

export const RenderConfig: ComponentConfig<ServiceSidebarProps> = {
  render: ({ className, styles, responsiveType, titleCategory, category, puck }) => {
    const id = `service-sidebar-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    return (
      <ServiceSidebarContent
        id={id}
        className={className}
        titleCategory={titleCategory}
        category={category}
        responsiveCSS={responsiveCSS}
        puck={puck}
      />
    )
  },
}
